import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Dumbbell, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
  ];

  const services = [
    { name: 'Strength & Conditioning', path: '/services/strength-conditioning' },
    { name: 'Weight Loss Programs', path: '/services/weight-loss' },
    { name: 'Bodybuilding Prep', path: '/services/bodybuilding-prep' },
    { name: 'Marathon Training', path: '/services/marathon-training' },
    { name: 'Lifestyle Coaching', path: '/services/lifestyle-coaching' },
    { name: 'Muscle Gain Programs', path: '/services/muscle-gain' },
  ];

  const otherLinks = [
    { name: 'Results', path: '/results' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' }
  ];

  const handleServiceClick = (path) => {
    window.location.href = path;
    setIsServicesOpen(false);
  };

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-wrapper">
        <div className="nav-content">
          <Link to="/" className="logo">
            <Dumbbell size={28} />
            <span className="logo-text">James Farina Personal Training</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            
            {/* Services Dropdown */}
            <div 
              className="nav-dropdown"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button className={`nav-link nav-dropdown-trigger ${location.pathname === '/services' ? 'active' : ''}`}>
                Services
                <ChevronDown size={16} className="dropdown-icon" />
              </button>
              
              {isServicesOpen && (
                <div className="nav-dropdown-menu">
                  {services.map((service, index) => (
                    <button
                      key={index}
                      onClick={() => handleServiceClick(service.path)}
                      className="nav-dropdown-item"
                    >
                      {service.name}
                    </button>
                  ))}
                  <Link
                    to="/services"
                    className="nav-dropdown-item all-services"
                    onClick={() => setIsServicesOpen(false)}
                  >
                    All Services
                  </Link>
                </div>
              )}
            </div>

            {otherLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            
            <Link to="/contact">
              <Button className="btn-primary nav-cta">Book Consultation</Button>
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="mobile-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            
            {/* Mobile Services Section */}
            <div className="mobile-services-section">
              <div className="mobile-section-title">Services</div>
              {services.map((service, index) => (
                <button
                  key={index}
                  onClick={() => handleServiceClick(service.path)}
                  className="mobile-nav-sublink"
                >
                  {service.name}
                </button>
              ))}
              <Link to="/services" className="mobile-nav-sublink all-services-mobile">
                All Services
              </Link>
            </div>

            {otherLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            
            <Link to="/contact" className="mobile-nav-cta">
              <Button className="btn-primary w-full">Book Consultation</Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
